import { Image, Text } from 'platform-components';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';

// @ts-ignore
import CreateClassButton from '../../create-class-button/create-class-button';

import './class-lessons__empty.scss';

interface HOCProps {
    intl: IntlShape;
}

export const Empty = ({ intl }: HOCProps) => {
    return (
        <div className="class-lessons__empty">
            <Image
                alt={intl.formatMessage({ id: 'lessons.withoutClass.addClass.description' })}
                className="class-lessons__empty-img"
                src={intl.formatMessage({ id: 'lessons.withoutClass.img' })}
            />
            <div className="class-lessons__empty-title">
                <Text id="lessons.withoutClass.addClass" size={Text.SIZE.XXL} weight={Text.WEIGHT.M} />
            </div>
            <div className="class-lessons__empty-description">
                <Text id="lessons.withoutClass.addClass.description" size={Text.SIZE.XL} />
            </div>
            <CreateClassButton />
        </div>
    );
};

export default injectIntl(Empty);
